import App from './App.svelte';

const basePath = '/spesial/2022/';

const element = document.getElementById('svelte-element');

const app = new App({
    target: element
});

export default app;
